import { createContext, useContext } from 'react'

export const DocumentContext = createContext<{
  document: Document
}>({
  document: null,
})

export const useDocument = () => useContext(DocumentContext)
